import { useEffect, useState } from 'react'

import exploreEvents from '@/utils/gaEvents/exploreEvents'

interface ParkinglotMoaiViewModel {
  text: object
  states: {
    isRecommand: boolean
    isNonRecommand: boolean
    isOpen: boolean
  }
  setter: {
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  }
  handlers: {
    onClickRecommandBtn: (cate: number, nrSeq: number) => void
    onClickNonRecommandBtn: (cate: number, nrSeq: number) => void
  }
}

interface useParkinglotMoaiViewModelProps {
  aiDescription: {
    response: string
    nrSeq: number
  }
}

const useParkinglotMoaiViewModel = ({ aiDescription }: useParkinglotMoaiViewModelProps): ParkinglotMoaiViewModel => {
  const [isRecommand, setIsRecommand] = useState(false)
  const [isNonRecommand, setIsNonRecommand] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const onClickRecommandBtn = (cate: number, nrSeq: number) => {
    if (isRecommand) return
    setIsRecommand(true)
    exploreEvents.common.onClickMoaiFeedBackButton(cate, nrSeq)
  }

  const onClickNonRecommandBtn = (cate: number, nrSeq: number) => {
    if (isNonRecommand) return
    setIsNonRecommand(true)
    exploreEvents.common.onClickMoaiFeedBackButton(cate, nrSeq)
  }

  useEffect(() => {
    setIsOpen(false)
    setIsRecommand(false)
    setIsNonRecommand(false)
  }, [aiDescription.response])

  return {
    text: {},
    states: {
      isRecommand,
      isNonRecommand,
      isOpen
    },
    setter: {
      setIsOpen
    },
    handlers: {
      onClickRecommandBtn,
      onClickNonRecommandBtn
    }
  }
}

export default useParkinglotMoaiViewModel
